<template>
  <div class="article-page-skeleton" aria-hidden="true">
    <div class="article-skeleton-container">
      <div class="skeleton-back-row">
        <div class="skeleton-button" />
      </div>
      <article class="article-skeleton-body">
        <!-- Hero -->
        <div class="skeleton-hero" />
        <!-- Meta -->
        <div class="skeleton-meta">
          <div class="skeleton-meta-item" />
          <div class="skeleton-meta-item" />
        </div>
        <!-- Title -->
        <div class="skeleton-title" />
        <!-- Content lines -->
        <div class="skeleton-line skeleton-line--long" />
        <div class="skeleton-line" />
        <div class="skeleton-line" />
        <div class="skeleton-line skeleton-line--short" />
        <div class="skeleton-line" />
        <div class="skeleton-line skeleton-line--medium" />
        <!-- Author -->
        <div class="skeleton-author" />
        <!-- CTA block -->
        <div class="skeleton-cta" />
      </article>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
.article-page-skeleton {
  max-width: var(--max-width-container);
  margin: 0 auto;
  padding: 0 40px;
}

.article-skeleton-container {
  max-width: var(--max-width-container);
  margin: 0 auto;
  padding: 0 40px;
  margin-top: 50px;
}

.article-skeleton-body {
  max-width: 800px;
  margin: 0 auto;
}

.skeleton-back-row {
  margin-bottom: 2rem;
}

.skeleton-button {
  width: 180px;
  height: 52px;
  border-radius: 8px;
  background: linear-gradient(
    90deg,
    var(--color-bg-faq, #eee) 0%,
    #e8e8e8 50%,
    var(--color-bg-faq, #eee) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
}

.skeleton-hero {
  width: 100%;
  aspect-ratio: 800 / 300;
  border-radius: 8px;
  margin-bottom: 24px;
  background: linear-gradient(
    90deg,
    var(--color-bg-faq, #eee) 0%,
    #e8e8e8 50%,
    var(--color-bg-faq, #eee) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
}

.skeleton-meta {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.skeleton-meta-item {
  width: 100px;
  height: 18px;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    var(--color-bg-faq, #eee) 0%,
    #e8e8e8 50%,
    var(--color-bg-faq, #eee) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
}

.skeleton-title {
  height: 48px;
  max-width: 90%;
  border-radius: 8px;
  margin-bottom: 24px;
  background: linear-gradient(
    90deg,
    var(--color-bg-faq, #eee) 0%,
    #e8e8e8 50%,
    var(--color-bg-faq, #eee) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
}

.skeleton-line {
  height: 16px;
  border-radius: 4px;
  margin-bottom: 12px;
  background: linear-gradient(
    90deg,
    var(--color-bg-faq, #eee) 0%,
    #e8e8e8 50%,
    var(--color-bg-faq, #eee) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
}

.skeleton-line--long {
  width: 100%;
}

.skeleton-line--medium {
  width: 75%;
}

.skeleton-line--short {
  width: 60%;
}

.skeleton-author {
  width: 200px;
  height: 20px;
  border-radius: 4px;
  margin-top: 24px;
  margin-bottom: 32px;
  background: linear-gradient(
    90deg,
    var(--color-bg-faq, #eee) 0%,
    #e8e8e8 50%,
    var(--color-bg-faq, #eee) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
}

.skeleton-cta {
  height: 120px;
  border-radius: 8px;
  background: linear-gradient(
    90deg,
    var(--color-bg-faq, #eee) 0%,
    #e8e8e8 50%,
    var(--color-bg-faq, #eee) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
}

@media (max-width: 991px) {
  .article-skeleton-container {
    padding: 0 30px;
  }

  .skeleton-title {
    height: 38px;
  }
}

@media (max-width: 767px) {
  .article-page-skeleton,
  .article-skeleton-container {
    padding: 0 20px;
  }

  .skeleton-title {
    height: 32px;
  }
}

@keyframes skeleton-shimmer {
  to {
    background-position: 200% 0;
  }
}
</style>
